import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectNewbuildingsCompareBlocks,
  selectNewbuildingsComparison,
  selectNewbuildingsCount,
} from '../../selectors/newbuildingsCompare';
import { NewbuildingsComparePage } from '../../components/NewbuildingsComparePage';
import { Cell } from '../../components/NewbuildingsComparePage/parts/Cell';
import { AiBannerContainer } from '../AiBanner';
import { AiSummaryModalDesktopContainer } from '../AiSummaryModalDesktop';
import { useCompareZhkUxfbEvent } from '../../hooks/useCompareZhkUxfbEvent';
import { buildNewbuildingsCompareViewRows } from './buildViewRows';

export const NewbuildingsComparePageContainer = () => {
  const comparison = useSelector(selectNewbuildingsComparison);
  const blocks = useSelector(selectNewbuildingsCompareBlocks);
  const newbuildingsCount = useSelector(selectNewbuildingsCount);

  useCompareZhkUxfbEvent('desktop', newbuildingsCount);
  const [isRoomStatsExpanded, setRoomStatsExpanded] = React.useState(false);
  const [isAiSummaryModalOpen, setAiSummaryModalOpen] = React.useState(false);

  const handleToggleRoomStats = React.useCallback(() => setRoomStatsExpanded(value => !value), []);
  const handleOpenAiSummaryModal = React.useCallback(() => setAiSummaryModalOpen(true), []);
  const handleAiSummaryModalOpenChange = React.useCallback((open: boolean) => setAiSummaryModalOpen(open), []);

  const { rows: tableRows, summaryRow } = buildNewbuildingsCompareViewRows({
    blocks,
    platform: 'desktop',
    isRoomStatsExpanded,
    onToggleRoomStats: handleToggleRoomStats,
    showDeveloperLinkRow: true,
  });

  if (!comparison) {
    return null;
  }

  const headers = [
    <AiBannerContainer key="ai-banner" onOpen={handleOpenAiSummaryModal} />,
    ...(summaryRow?.cells.map((cell, index) => <Cell cell={cell} key={index} type={summaryRow.type} />) ?? []),
  ];
  const floatingHeaders = [
    '',
    ...(summaryRow?.cells.map((cell, index) => <Cell cell={cell} floating key={index} type={summaryRow.type} />) ?? []),
  ];

  return (
    <>
      <NewbuildingsComparePage
        floatingHeaders={floatingHeaders}
        headers={headers}
        onAiSummaryOpen={handleOpenAiSummaryModal}
        rows={tableRows}
        title={comparison.title}
      />
      <AiSummaryModalDesktopContainer onOpenChange={handleAiSummaryModalOpenChange} open={isAiSummaryModalOpen} />
    </>
  );
};
